import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WHATSAPP_LINK = "https://api.whatsapp.com/send/?phone=5508000155555&text&type=phone_number&app_absent=0";

const WhatsAppButton = () => {
  return (
    <motion.a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 whatsapp-pulse"
      data-testid="whatsapp-float-button"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full shadow-lg hover:bg-[#20c25c] transition-colors">
        <MessageCircle className="w-7 h-7 md:w-8 md:h-8 text-white" fill="white" />
      </div>
    </motion.a>
  );
};

export default WhatsAppButton;
